import { FC } from 'react'
import StandingsHeaderWithConfig from '@sport1/news-styleguide/StandingsHeaderWithConfig'

const NbaHeader: FC = () => (
    <StandingsHeaderWithConfig
        columns={[
            {
                value: 'Sp.',
                width: [30, 30, 48, 48],
            },
            {
                value: 'S-N',
                width: [40, 40, 56, 64],
            },
            {
                value: '%',
                width: [48, 48, 56, 64],
            },
            {
                value: 'GB',
                width: [34, 34, 40, 40],
            },
            {
                value: '+/-',
                width: [0, 0, 80, 80],
                display: ['none', 'none', 'flex', 'flex'],
            },
            {
                value: 'Diff.',
                width: [0, 0, 56, 64],
                display: ['none', 'none', 'flex', 'flex'],
            },
            {
                value: 'Serie',
                width: [34, 34, 56, 64],
            },
        ]}
    />
)

export default NbaHeader
